import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button", "checkbox", "container"]
  static values = { size: { type: String, default: "md" } } // 'sm' или 'md'

  connect() {
    this.updateVisibility()
  }

  toggleVisibility() {
    this.updateVisibility()
  }

  updateVisibility() {
    if (!this.hasCheckboxTarget) return

    if (this.checkboxTarget.checked) {
      this.containerTarget.classList.remove("hidden")
    } else {
      this.containerTarget.classList.add("hidden")
      this.inputTarget.value = ""
    }
  }

  select(event) {
    const clickedButton = event.currentTarget
    const selectedValue = clickedButton.dataset.value

    if (this.inputTarget.value === selectedValue || selectedValue === "") {
      this.inputTarget.value = ""
      this.resetButtonStyles()

      if (this.hasCheckboxTarget) {
        this.checkboxTarget.checked = false
        this.updateVisibility()
      }
    } else {
      this.inputTarget.value = selectedValue
      this.updateButtonStyles(selectedValue)
    }

    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  get stylesConfig() {
    const isSm = this.sizeValue === "sm"

    const btnBase = isSm
      ? "inline-flex items-center gap-x-1 rounded-md border px-2 py-1 text-xs font-medium shadow-sm cursor-pointer transition-all focus:outline-none"
      : "inline-flex items-center gap-x-1.5 rounded-lg border px-3 py-2 text-sm font-medium shadow-sm cursor-pointer transition-all focus:outline-none"

    const dotSize = isSm ? "size-1.5" : "size-2.5"

    return {
      red: {
        active: `${btnBase} bg-red-600 border-red-700 text-white ring-2 ring-red-500/20`,
        inactive: `${btnBase} border-red-200 bg-red-50/30 text-red-700 hover:bg-red-50/60`,
        dotInactive: `${dotSize} rounded-full bg-red-500 border border-red-600/20`
      },
      yellow: {
        active: `${btnBase} bg-yellow-500 border-yellow-600 text-white ring-2 ring-yellow-500/20`,
        inactive: `${btnBase} border-yellow-200 bg-yellow-50/30 text-yellow-800 hover:bg-yellow-50/60`,
        dotInactive: `${dotSize} rounded-full bg-yellow-500 border border-yellow-600/20`
      },
      "": {
        active: `${btnBase} bg-slate-600 border-slate-700 text-white ring-2 ring-slate-500/20`,
        inactive: `${btnBase} border-slate-200 bg-slate-50/30 text-slate-700 hover:bg-slate-50/60`,
        dotInactive: `${dotSize} rounded-full bg-slate-400 border border-slate-500/20`
      },
      dotSize: dotSize
    }
  }

  resetButtonStyles() {
    this.buttonTargets.forEach(btn => {
      const value = btn.dataset.value || ""
      const config = this.stylesConfig[value]
      const dot = btn.querySelector("span")

      if (config) {
        btn.className = config.inactive
        if (dot) dot.className = config.dotInactive
      }
    })
  }

  updateButtonStyles(activeValue) {
    this.resetButtonStyles()

    const activeBtn = this.buttonTargets.find(btn => (btn.dataset.value || "") === activeValue)
    if (!activeBtn) return

    const config = this.stylesConfig[activeValue]
    if (!config) return

    activeBtn.className = config.active
    const dot = activeBtn.querySelector("span")
    if (dot) dot.className = `${this.stylesConfig.dotSize} rounded-full bg-white`
  }
}
